import { Component } from 'react'
import { observer } from 'mobx-react'
import ReactDOM from 'react-dom'
import $ from 'jquery'

import * as h from 'h'

import { menu } from 'config'

import UConnBanner from 'components/UConnBanner'

import Menu from './Menu'
import StandardPanel from './StandardPanel'
import LogoPanel from './LogoPanel'
import ResearchUnleashedPanel from './ResearchUnleashedPanel'
import StoriesPanel from './StoriesPanel'
import UconnLogo from './UconnLogo'

import styles from './styles.scss'

@observer(['UiStore'])
export default class ActualLanding extends Component {
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentDidMount () {
    const { UiStore } = this.props

    // don't want to flicker the landing transition
    // if we aren't on the landing route
    if (!UiStore.showLanding) {
      setTimeout(() => {
        UiStore.landingDidMount()
      }, 400)
    } else {
      UiStore.landingDidMount()
    }
  }

  componentWillReact () {
    const { UiStore } = this.props

    // This is a landing panel slug, not null whenever a
    // [hamburger] sidemenu item heading is clicked
    if (UiStore.scrollToLandingPanelNext) {
      /* We want the landing to show the page the user clicked on while
       * animated down. If we ever need to scroll to the panel after the landing
       * has fully moved down, delay can be changed to 800ms, the duration of
       * the animation. */
      this.scrollToPanel(UiStore.scrollToLandingPanelNext, {
        delay: 0,
        speed: 0,
        offScreen: true
      })

      UiStore.scrollToLandingPanelNext = null
    }
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------

  scrollToPanel (slug, { delay = 0, speed = 500, offScreen = false } = {}) {
    const $landing = $(this.refs.landing)
    const $el = slug === 'twitter'
      ? $('#twitter-anchor')
      : $(ReactDOM.findDOMNode(this.refs[`landing-panel-${slug}`]))

    /* If we're offscreen, we need to add the height of the element since
     * scrollTop will put the top of the element at browser y=0. This causes the
     * previous slide to shown without the below correction. */
    const offScreenOffset = offScreen ? $el.height() : 0

    if ($el.length) {
      setTimeout(() => {
        $landing.animate({
          scrollTop: $landing.scrollTop() + $el.offset().top + offScreenOffset
        }, speed)
      }, delay)
    }
  }

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------

  get menu () {
    return menu.filter(item => !item.noMain && !item.hidden)
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { UiStore: { landingMounted, showLanding } } = this.props

    const landingClasses = h.ca(
      styles.landing,
      { [styles.show]: showLanding,
        [styles.withTransition]: landingMounted
      }
    )

    const m = this.menu.filter(item => !item.url && !item.landingOnly)

    return h.div(h.ca(styles.container),
    // landing
    h.div({ ref: 'landing', ...landingClasses },
      // panels must be first children for css background image matching
      h.h(LogoPanel, {
        ref: 'landing-panel-logo',
        onArrowClick: () => {
          this.scrollToPanel('researchunleashed')
        }
      }),
      h.h(ResearchUnleashedPanel, {
        ref: 'landing-panel-researchunleashed',
        onArrowClick: () => {
          this.scrollToPanel(m[0].slug)
        }
      }),
      m.filter(item => !item.noLanding)
       .map((item, i) => h.h(StandardPanel, {
         key: item.slug,
         ref: `landing-panel-${item.slug}`,
         item,
         onArrowClick: () => {
           this.scrollToPanel(m[i + 1] ? m[i + 1].slug : 'stories')
         }
       })),
      h.h(StoriesPanel, {
        ref: 'landing-panel-stories'
      }),
      h.h(UConnBanner)),
      h.maybe(showLanding, h.h(UconnLogo, { landing: this.refs.landing })),
    // menu
    h.maybe(showLanding, h.h(Menu, { menu: this.menu, onClick: ::this.scrollToPanel })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/ActualLanding.js